module.exports = __webpack_public_path__ + "img/italie.612e617f.svg";